<div *ngIf="canViewSkillSuggestions" class="skill-suggestions-container">
  <div
    class="l_flex l_flex-justify"
    [ngClass]="{ 'guts-m-b-1': isSkillSuggestionsOpen }"
  >
    <div>
      <h3 class="h3 cap-me">
        {{ 'dgProfileOverview_SkillSuggestionsTitle' | translate }}
      </h3>
      <p *ngIf="isSkillSuggestionsOpen" class="par--light_a par--small">
        {{ 'dgProfileOverview_SkillSuggestionsSubTitle' | translate }}
      </p>
    </div>
    <button
      type="button"
      (click)="toggleSkillSuggestionsOpen()"
      attr.aria-expanded="{{ isSkillSuggestionsOpen }}"
      data-dgat="profile-skill-suggestions-70c">
      <df-icon
        class="color-ebony-a61 guts-m-h-1"
        size="medium"
        [icon]="isSkillSuggestionsOpen ? 'chevron-up' : 'chevron-down'"
      ></df-icon>
    </button>
  </div>
  <dgx-tag-suggestions
    *ngIf="isSkillSuggestionsOpen"
    [isLoading]="isSuggestedTagsLoading"
    [suggestedTags]="suggestedTags"
    [tags]="tags"
    (onAddSuggestedTag)="handleAddSuggestedTag($event)"
  ></dgx-tag-suggestions>
</div>
